// React.lazy doesn't work with HMR
import loadable from "@loadable/component";

export const illustrationSvgMap = {
  activeCat: loadable(() => import("./illustrations/ActiveCat")),
  activityIndoorAndOutdoor: loadable(() => import("./illustrations/ActivityIndoorAndOutdoor")),
  activityIndoorHigh: loadable(() => import("./illustrations/ActivityIndoorHigh")),
  activityIndoorLow: loadable(() => import("./illustrations/ActivityIndoorLow")),
  activityMostlyOutdoor: loadable(() => import("./illustrations/ActivityMostlyOutdoor")),
  adultAge: loadable(() => import("./illustrations/AdultAge")),
  badBacteria: loadable(() => import("./illustrations/BadBacteria")),
  benefitHealthierWeight: loadable(() => import("./illustrations/BenefitHealthierWeight")),
  benefitLessMess: loadable(() => import("./illustrations/BenefitLessMess")),
  benefitMoreEnergy: loadable(() => import("./illustrations/BenefitMoreEnergy")),
  benefitShinyCoat: loadable(() => import("./illustrations/BenefitShinyCoat")),
  bodyTypeJustRight: loadable(() => import("./illustrations/BodyTypeJustRight")),
  bodyTypeOverweight: loadable(() => import("./illustrations/BodyTypeOverweight")),
  bodyTypeThin: loadable(() => import("./illustrations/BodyTypeThin")),
  bodyTypeVeryOverweight: loadable(() => import("./illustrations/BodyTypeVeryOverweight")),
  bodyTypeVeryThin: loadable(() => import("./illustrations/BodyTypeVeryThin")),
  canBeFussy: loadable(() => import("./illustrations/CanBeFussy")),
  catBackwards: loadable(() => import("./illustrations/CatBackwards")),
  catEatingDrumstick: loadable(() => import("./illustrations/CatEatingDrumstick")),
  catFreshInside: loadable(() => import("./illustrations/CatFreshInside")),
  catPeeking: loadable(() => import("./illustrations/CatPeeking")),
  catProfileLongHair: loadable(() => import("./illustrations/CatProfileLongHair")),
  catProfileShortHair: loadable(() => import("./illustrations/CatProfileShortHair")),
  chubbyBodyTypeDualSilhouette: loadable(() => import("./illustrations/ChubbyBodyTypeDualSilhouette")),
  coins: loadable(() => import("./illustrations/Coins")),
  diamond: loadable(() => import("./illustrations/Diamond")),
  diningCat: loadable(() => import("./illustrations/DiningCat")),
  doctorCat: loadable(() => import("./illustrations/DoctorCat")),
  eatsAnything: loadable(() => import("./illustrations/EatsAnything")),
  emptyBowl: loadable(() => import("./illustrations/EmptyBowl")),
  explorerCat: loadable(() => import("./illustrations/ExplorerCat")),
  foodBowl: loadable(() => import("./illustrations/FoodBowl")),
  freshInside: loadable(() => import("./illustrations/FreshInside")),
  freshStart: loadable(() => import("./illustrations/FreshStart")),
  fullCat: loadable(() => import("./illustrations/FullCat")),
  groomingCat: loadable(() => import("./illustrations/GroomingCat")),
  happyHealthyCat: loadable(() => import("./illustrations/HappyHealthyCat")),
  hardToPlease: loadable(() => import("./illustrations/HardToPlease")),
  heartMessage: loadable(() => import("./illustrations/HeartMessage")),
  hungryCat: loadable(() => import("./illustrations/HungryCat")),
  inactiveCat: loadable(() => import("./illustrations/InactiveCat")),
  joinTheClub: loadable(() => import("./illustrations/JoinTheClub")),
  justRightBodyTypeDualSilhouette: loadable(() => import("./illustrations/JustRightBodyTypeDualSilhouette")),
  kittenAge: loadable(() => import("./illustrations/KittenAge")),
  kkTrays: loadable(() => import("./illustrations/KKTrays")),
  kkTray: loadable(() => import("./illustrations/KKTray")),
  legOfMeat: loadable(() => import("./illustrations/LegOfMeat")),
  magnifyingCat: loadable(() => import("./illustrations/MagnifyingCat")),
  moreMeatForLess: loadable(() => import("./illustrations/MoreMeatForLess")),
  moreRealMeat: loadable(() => import("./illustrations/MoreRealMeat")),
  obeseBodyTypeDualSilhouette: loadable(() => import("./illustrations/ObeseBodyTypeDualSilhouette")),
  padlockUnlocked: loadable(() => import("./illustrations/PadlockUnlocked")),
  seniorAge: loadable(() => import("./illustrations/SeniorAge")),
  skinnyBodyTypeDualSilhouette: loadable(() => import("./illustrations/SkinnyBodyTypeDualSilhouette")),
  sms: loadable(() => import("./illustrations/Sms")),
  sparkleLarge: loadable(() => import("./illustrations/SparkleLarge")),
  sparkleSmall: loadable(() => import("./illustrations/SparkleSmall")),
  standingCat: loadable(() => import("./illustrations/StandingCat")),
  superCat: loadable(() => import("./illustrations/SuperCat")),
  swirlyArrow: loadable(() => import("./illustrations/SwirlyArrow")),
  tray: loadable(() => import("./illustrations/Tray")),
  typingCat: loadable(() => import("./illustrations/TypingCat")),
  wastedFood: loadable(() => import("./illustrations/WastedFood")),
  weighingScales: loadable(() => import("./illustrations/WeighingScales")),
};

export const illustrationSizeClassMap = {
  fit: "w-full h-full",
  xsmall: "w-6 h-6 md:w-8 md:h-8",
  small: "w-10 h-10 md:w-12 md:h-12",
  medium: "w-12 h-12 md:w-14 md:h-14",
  mediumLarge: "w-16 h-16 md:w-20 md:h-20",
  large: "w-28 h-28 md:w-32 md:h-32",
};

export type Size = keyof typeof illustrationSizeClassMap;
export type IllustrationSvg = keyof typeof illustrationSvgMap;
